import { create } from "zustand";

export interface SearchFilters {
  retailer: string;
  minPrice?: number;
  maxPrice?: number;
  minRating?: number;
  sortBy?: "price" | "rating" | "relevance";
}

export interface SearchHistoryItem {
  query: string;
  retailer: string;
  timestamp: number;
  resultCount: number;
}

interface SearchState {
  // Current search
  currentQuery: string;
  currentRetailer: string;
  currentFilters: SearchFilters;

  // Search history
  searchHistory: SearchHistoryItem[];

  // Actions
  setCurrentSearch: (query: string, retailer: string) => void;
  setFilters: (filters: Partial<SearchFilters>) => void;
  addToHistory: (item: Omit<SearchHistoryItem, "timestamp">) => void;
  clearHistory: () => void;
  removeFromHistory: (timestamp: number) => void;
}

export const useSearchStore = create<SearchState>((set, get) => ({
  // Initial state
  currentQuery: "",
  currentRetailer: "amazon",
  currentFilters: {
    retailer: "amazon",
  },
  searchHistory: [],

  // Actions
  setCurrentSearch: (query: string, retailer: string) =>
    set({
      currentQuery: query,
      currentRetailer: retailer,
      currentFilters: { ...get().currentFilters, retailer },
    }),

  setFilters: (filters: Partial<SearchFilters>) =>
    set({
      currentFilters: { ...get().currentFilters, ...filters },
    }),

  addToHistory: (item: Omit<SearchHistoryItem, "timestamp">) =>
    set((state) => ({
      searchHistory: [
        { ...item, timestamp: Date.now() },
        ...state.searchHistory.filter(
          (h) => !(h.query === item.query && h.retailer === item.retailer),
        ),
      ].slice(0, 10), // Keep only last 10 searches
    })),

  clearHistory: () => set({ searchHistory: [] }),

  removeFromHistory: (timestamp: number) =>
    set((state) => ({
      searchHistory: state.searchHistory.filter(
        (h) => h.timestamp !== timestamp,
      ),
    })),
}));
